/* Keep Christmas theme personalization consistent through Shopify variant updates. */
(() => {
  if(window.__svChristmasThemePickerInstalled) return;
  window.__svChristmasThemePickerInstalled = true;
  let selected = null;
  const themes = {
    'Santa Chic':'shih-tzu-santa-example',
    'Reindeer Glam':'poodle-reindeer-example',
    'Holiday Diva':'dachshund-scarf-example',
    'Christmas Sweetheart':'dog-bow-example'
  };
  const getInputs = () => Array.from(document.querySelectorAll(
    'product-form-component[data-product-id="11350876619095"] input[name="properties[Christmas theme]"]'
  ));
  const focusThemeImage = (theme) => {
    const token=themes[theme];
    if(!token) return;
    const gallery=document.querySelector('media-gallery');
    const slideshow=gallery?.slideshow;
    if(!slideshow) return;
    const slides=Array.from(slideshow.slides||[]);
    const index=slides.findIndex(slide=>{
      const image=slide.querySelector('img.product-media__image');
      return image && ((image.getAttribute('src')||'')+' '+(image.getAttribute('alt')||'')).toLowerCase().includes(token);
    });
    if(index>=0) void slideshow.select(index,undefined,{animate:false});
  };
  document.addEventListener('change',(event)=>{
    const input=event.target;
    if(!(input instanceof HTMLInputElement)) return;
    if(input.name!=='properties[Christmas theme]' || !input.closest('[data-sv-christmas-theme-picker]')) return;
    selected=input.value;
    focusThemeImage(selected);
  },true);
  // Some Shopify themes refresh the form when a size or zipper is selected.
  // Restore the customer's chosen design without changing the physical variant.
  new MutationObserver(()=>{
    if(!selected) return;
    const chosen=getInputs().find(input=>input.value===selected);
    if(chosen&&!chosen.checked)chosen.checked=true;
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
